import { render } from "./IconLogout.vue?vue&type=template&id=7dc9d933"
import script from "./IconLogout.vue?vue&type=script&lang=js"
export * from "./IconLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__